import React, { useEffect, useState } from 'react';

const EditProfileModal = ({ open, onClose, initialProfile }) => {
  const [firstName, setFirstName] = useState('');
  const [middleInitial, setMiddleInitial] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        if (initialProfile) {
          setFirstName(initialProfile.first_name || '');
          setMiddleInitial((initialProfile.middle_initial || '').slice(0,1));
          setLastName(initialProfile.last_name || '');
          setEmail(initialProfile.email || '');
          return;
        }
        const token = localStorage.getItem('authToken');
        const baseApiUrl = process.env.REACT_APP_API_URL || 'https://api.example.com';
        const resp = await fetch(`${baseApiUrl}/auth/profile`, {
          method: 'GET',
          headers: { 'Authorization': `Bearer ${token}` },
        });
        const text = await resp.text();
        let data = {};
        try { data = text ? JSON.parse(text) : {}; } catch {}
        if (!resp.ok) {
          setError(data.message || data.error || `Error: ${resp.status}`);
          return;
        }
        const p = (data && data.data && data.data.profile) || {};
        setFirstName(p.first_name || '');
        setMiddleInitial((p.middle_initial || '').slice(0,1));
        setLastName(p.last_name || '');
        setEmail(p.email || '');
      } catch (e) {
        setError('Failed to load profile');
      } finally {
        setLoading(false);
      }
    };
    if (open) load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, initialProfile]);

  if (!open) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setSuccess('');
    try {
      setLoading(true);
      const token = localStorage.getItem('authToken');
      const baseApiUrl = process.env.REACT_APP_API_URL || 'https://api.example.com';
      const resp = await fetch(`${baseApiUrl}/auth/profile`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
          first_name: firstName,
          middle_initial: (middleInitial || '').slice(0,1),
          last_name: lastName,
          email: email,
        }),
      });
      const text = await resp.text();
      let data = {};
      try { data = text ? JSON.parse(text) : {}; } catch {}
      if (!resp.ok) {
        setError(data.message || data.error || `Error: ${resp.status}`);
        return;
      }
      setSuccess('Profile updated');
      setTimeout(() => onClose?.(), 1000);
    } catch (e) {
      setError('Network error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-20">
      <div className="bg-white rounded shadow-lg w-full max-w-md mx-4">
        <div className="px-4 py-3 border-b border-gray-200 flex items-center justify-between">
          <h3 className="text-lg font-medium text-gray-900">Edit Profile</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">✕</button>
        </div>
        <form className="px-4 py-4" onSubmit={handleSubmit}>
          {error && <div className="text-sm text-red-600 mb-2">{error}</div>}
          {success && <div className="text-sm text-green-600 mb-2">{success}</div>}
          <div className="mb-3">
            <label className="block text-sm text-gray-700 mb-1">First name</label>
            <input className="w-full border border-gray-300 rounded px-3 py-2" value={firstName} onChange={(e) => setFirstName(e.target.value)} required />
          </div>
          <div className="mb-3">
            <label className="block text-sm text-gray-700 mb-1">Middle initial</label>
            <input className="w-full border border-gray-300 rounded px-3 py-2" value={middleInitial} onChange={(e) => setMiddleInitial(e.target.value.slice(0,1))} />
          </div>
          <div className="mb-3">
            <label className="block text-sm text-gray-700 mb-1">Last name</label>
            <input className="w-full border border-gray-300 rounded px-3 py-2" value={lastName} onChange={(e) => setLastName(e.target.value)} required />
          </div>
          <div className="mb-4">
            <label className="block text-sm text-gray-700 mb-1">Email</label>
            <input type="email" className="w-full border border-gray-300 rounded px-3 py-2" value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div className="flex justify-end space-x-2">
            <button type="button" onClick={onClose} className="px-3 py-2 text-sm text-gray-600 hover:text-gray-800">Cancel</button>
            <button type="submit" disabled={loading} className="px-3 py-2 text-sm bg-indigo-600 text-white rounded hover:bg-indigo-700 disabled:opacity-50">{loading ? 'Saving...' : 'Save'}</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditProfileModal;


